var Component = require("!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-b2542b4e!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./repom-redirect.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/external/repom-redirect.vue
// module id = 2020
// module chunks = 1